export const getNextItemsInCyclicalList = <T extends { id: string }>({
  amount = 3,
  items,
  targetId,
}: {
  amount?: number;
  items: T[];
  targetId: string;
}): T[] => {
  const foundIndex = items.findIndex((item) => item.id === targetId);

  if (foundIndex === -1) return [];

  const firstHalf = items.slice(0, foundIndex);
  const secondHalf = items.slice(foundIndex + 1);

  return [...secondHalf, ...firstHalf].slice(0, amount);
};
